import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-product-list",
  "use": "icon-product-list-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-product-list\"><path d=\"M810.752 106.666667c22.613333 0 44.288 8.96 60.288 24.874666 16 15.957333 24.96 37.546667 24.96 60.117334V748.8H248.661333a42.538667 42.538667 0 0 0-42.624 42.496c0 23.466667 19.114667 42.496 42.666667 42.496H896a85.12 85.12 0 0 1-85.248 83.541333H213.248c-22.613333 0-44.288-8.96-60.288-24.874666A84.864 84.864 0 0 1 128 832.341333V191.658667c0-46.933333 38.144-84.992 85.248-84.992z m-326.997333 129.792H362.325333v386.133333h126.72c143.189333 4.650667 212.48-60.885333 207.786667-196.565333-2.346667-125.184-73.386667-188.373333-213.077333-189.568z m-0.426667 72.874666c83.968 1.152 127.232 40.533333 129.706667 118.101334 0 83.413333-43.306667 125.098667-129.92 125.098666h-31.744v-243.2z\" fill=\"\" p-id=\"45978\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/product-list.svg
// module id = qzoa
// module chunks = 19